const baseSize = 16

function setRem() {
	const scale = document.documentElement.clientWidth / 1920
	let fontSize = (baseSize * Math.min(scale, 2)) > 8 ? (baseSize * Math.min(scale, 2)) : 8
	document.documentElement.style.fontSize = fontSize + 'px'
}
setRem()
window.onresize = function() {
	setRem()
}
